import React, { useState, useEffect } from "react";
import axios from "react-axios";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Skeleton from "react-loading-skeleton";
import { Helmet } from "react-helmet";

import "../../css/tracks.less";

import styled from "styled-components";

export const IntroHeader = styled.section`
  font-size: 14px;
  margin: 0 auto 40px auto;
  text-align: center;
`;
export const Intro = styled.section`
  font-size: 12px;
  margin-top: -6px;
`;
export const IntroMessage = styled.section`
  font-size: 14px;
  width: 90%;
  margin: 20px auto 0 auto;
`;
export const Tags = styled.section`
  font-size: 18px;
  font-weight: bold;
`;

const PromoTracksPage = (props) => {
  const [promos, setPromos] = useState([]);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const promosTracks = await axios("//www.dreamchimney.com/api/tracks/promotracks");
      setPromos(promosTracks.data);
      setRecent(promosTracks.data.slice(1, 21));
      setLoading(false);
    }
    fetchData();
  }, []);

  return (
    <div className="page-promo-tracks">
      <Helmet>
        <title>DC Promo Tracks | Dream Chimney</title>
      </Helmet>
      <div>
        <IntroHeader>
          <img src="//dreamchimney.com/tracks/images/dc_promo_tracks.png" className="img-fluid" alt="Promo Tracks" />
          <Intro>Exclusives, debuts and premieres from our favorite artists/labels.</Intro>
          <IntroMessage>
            After receiving so many amazing promos over the years, we have decided to feature some of them. Listen, favorite and dont forget
            to "add to cart".
            <br />
            Follow us{" "}
            <a href="https://soundcloud.com/the-dream-chimney" target="_blank" rel="noopener noreferrer">
              @the-dream-chimney
            </a>{" "}
            or{" "}
            <a href="http://eepurl.com/dN23Jw" target="_blank" rel="noopener noreferrer">
              subscribe to our weekly email
            </a>
            .
          </IntroMessage>
        </IntroHeader>
        <Row style={{ marginBottom: "30px" }}>
          <Col xs={12}>
            {loading && <Skeleton count="3" />}
            <div>
              {!loading && (
                <div>
                  <div className="totd-header">
                    <h2>
                      #{promos[0].id} {promos[0].artist} "{promos[0].title}"
                    </h2>
                  </div>
                  <div>
                    <iframe width="100%" height="166" scrolling="no" frameborder="no" src={promos[0].embed_url}></iframe>
                  </div>
                  <Tags>Tags: {promos[0].tags}</Tags>
                </div>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <h2>More Recent Tracks</h2>
          </Col>
        </Row>
        {loading && <Skeleton count="6" />}
        <Row>
          {recent.map((promo) => (
            <Col xs={12} sm={6} md={3} style={{ textAlign: "center", marginBottom: "10px", minHeight: "240px" }}>
              <div className="totd-header-thin">
                <div>
                  #{promo.id} {promo.artist} "{promo.title}"
                </div>
              </div>
              <a href={promo.sc_url} target="_blank" rel="noopener noreferrer">
                <img src={`//www.dreamchimney.com/tracks/images/promo-tracks/${promo.id}.jpg`} className="img-fluid" alt="Promo Tracks" />
              </a>
            </Col>
          ))}
        </Row>
        <Row style={{ marginTop: "40px" }}>
          <Col xs={12} className="text-center">
            <Button variant="outline-dark">
              <a href={`https://www.dreamchimney.com/promos`} target="_blank" rel="noopener noreferrer">
                More Promos
              </a>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PromoTracksPage;
